import styles from 'sections/works/works.module.css';

import React from 'react';
import { WorksItem } from 'sections/works/WorksItem';
import { IWork } from 'sections/works/interfaces';
import { getItemTopPosition } from 'sections/works/utils/getItemTopPosition.utils';

export interface IWorkList {
    workList: IWork[];
}

const WorkList = ({ workList }: IWorkList) => {
    return (
        <ul className={styles.works}>
            {workList.map((item, index) => {
                return (
                    <li
                        key={item.id}
                        style={{
                            position: 'sticky',
                            top: getItemTopPosition(index),
                        }}
                    >
                        <WorksItem item={item} />
                    </li>
                );
            })}
        </ul>
    );
};

export default WorkList;
